import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import BlockTestimonialCarousel from '@berlitz/blocks/lib/BlockTestimonialCarousel'

const GOOGLE_REVIEWS_QUERY = graphql`
  query GoogleReviews {
    allGoogleReview {
      edges {
        node {
          id
          text
          rating
          profile_photo_url
          author_name
          isDummy
        }
      }
    }
  }
`

const SliceGoogleReviews = ({ primary }) => {
  const renderCarousel = reviews => {
    const filteredReviews = reviews
      .filter(item => item.node.rating === 5)
      .map(item => ({
        author: item.node.author_name,
        byline: item.node.author_name,
        image: item.node.profile_photo_url,
        text: item.node.text ? <span>{item.node.text}</span> : null,
      }))

    return (
      <BlockTestimonialCarousel
        title={primary?.reviews_title?.text}
        subtitle={primary?.reviews_subtitle?.text}
        backgroundColor="blue"
        testimonials={filteredReviews}
      />
    )
  }

  return (
    <StaticQuery
      query={GOOGLE_REVIEWS_QUERY}
      render={data => {
        const reviews = data?.allGoogleReview?.edges ?? []
        if (reviews[0]?.node?.isDummy) return null
        return renderCarousel(reviews)
      }}
    />
  )
}

export default SliceGoogleReviews
